import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class SvgIconService {
    icons = [
        'notfallkontakte',
        'persoenlich',
        'gesundheit',
        'kontakte',
        'notrufdienst',
        'orientierung',
        'routine',
        'trinken',
        'bewegung',
        'termine',
        'fragebogen',
        'uebungen',
        'wissen',
        'faq',
        'anleitungen',
        'nutzer',
        'geraete',
        'gesundheit02',
        'anleitungen02',
        'geraete02',
        'routine02',
        'notes',
        'medPlan',
        'medPlan2',
        'section-sign',
        'hochschieben',
        'battery_half',
        'battery_3q',
        'battery_charging',
        'smart-speaker'
    ];

    /**
     * Constructor
     */
    constructor(
        private matIconRegistry: MatIconRegistry,
        private domSanitizer: DomSanitizer,
    ) {}

    addIcons() {
        this.icons.forEach((icon) => {
            this.matIconRegistry.addSvgIcon(
                icon,
                this.domSanitizer.bypassSecurityTrustResourceUrl(
                    `assets/icons/adele/${icon}.svg`,
                ),
            );
        });
    }
}
